let apiBase = {
  queryNotifyDetail: '/api/paccount/message/notifyDetail',

}
let singleMessageServerObject = null

class MessageServer {
    constructor() {}
    //获取消息详情
    queryNotifyDetail(params = {}) {
        return $http({
            method: 'get',
            url: apiBase.queryNotifyDetail,
            params: params,
        })
    }
}

function singleMessageServer() {
    if (singleMessageServerObject === null) {
        singleMessageServerObject = new MessageServer()
    }
    return singleMessageServerObject
}

export default singleMessageServer()